import {
	GET_CATALOGS_REPORTS,
	GET_CATALOGS_REPORTS_ERROR,
	GET_CATALOGS_REPORTS_SUCCESS,
	GET_CATALOGS_REPORTS_ERROR_SHOW,
} from '../../constants';

export const getCatalogsReportReducer = (state, actions) => {
	switch (actions.type) {
		case GET_CATALOGS_REPORTS:
			return {
				...state,
				loading: true,
			};
		case GET_CATALOGS_REPORTS_ERROR:
			return {
				catalogs: state.catalogs,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case GET_CATALOGS_REPORTS_SUCCESS:
			return {
				catalogs: actions.payload,
				loading: false,
				error: null,
				errorShow: false,
			};
		case GET_CATALOGS_REPORTS_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
